import React, { useRef, useEffect } from 'react';
import { GiCampfire, GiWineGlass, GiKnifeFork, GiMeat } from 'react-icons/gi';
import './Gallery.css';

const galleryItems = [
  { icon: <GiMeat />, label: 'Charcoal Grill', category: 'Signature', size: 'large' },
  { icon: <GiKnifeFork />, label: 'Fine Dining', category: 'Ambience', size: 'small' },
  { icon: <GiCampfire />, label: 'Open Flame', category: 'Craft', size: 'small' },
  { icon: <GiWineGlass />, label: 'Beverages', category: 'Drinks', size: 'medium' },
  { icon: <GiKnifeFork />, label: 'Table Setting', category: 'Ambience', size: 'medium' },
  { icon: <GiMeat />, label: 'Grilled Chicken', category: 'Mains', size: 'large' },
];


const Gallery = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('in-view');
        });
      },
      { threshold: 0.1 }
    );
    sectionRef.current?.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="gallery" className="gallery section-padding" ref={sectionRef}>
      <div className="gallery-bg" />
      <div className="container">

        {/* Header */}
        <div className="section-header reveal">
          <span className="section-tag">Atmosphere</span>
          <div className="gold-line"><div className="gold-diamond" /></div>
          <h2 className="section-title">Gallery</h2>
          <p className="section-subtitle" style={{ marginTop: '16px' }}>
            A glimpse into the world of The Charcoal Grill
          </p>
        </div>

        {/* Abstract Gallery Grid */}
        <div className="gallery-grid reveal">
          {galleryItems.map((item, i) => (
            <div
              className={`gallery-item gallery-item--${item.size}`}
              key={i}
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <div className="gallery-item-inner">
                <div className="gallery-item-bg" />
                <div className="gallery-icon">{item.icon}</div>
                <div className="gallery-item-info">
                  <span className="gallery-category">{item.category}</span>
                  <h4 className="gallery-label">{item.label}</h4>
                </div>
                <div className="gallery-overlay" />
              </div>
            </div>
          ))}
        </div>

        {/* Photo Coming Soon Banner */}
        <div className="gallery-coming-soon reveal">
          <div className="coming-soon-inner">
            <GiCampfire className="cs-icon" />
            <div className="cs-text">
              <p className="cs-title">Professional Photography Coming Soon</p>
              <p className="cs-sub">Our gallery will be updated with stunning professional shots of our restaurant and signature dishes</p>
            </div>
          </div>
        </div>


      </div>
    </section>
  );
};

export default Gallery;
